import { Chip, Box, IconButton } from '@mui/material';
import { InsightType } from '../../apis';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { getUniFormatDisplayTitle, MappedInsightType } from '../../queries/useInsightsQuery';
import { SyntheticEvent, useRef, useState } from 'react';
import MenuPopup from './MenuPopup';
import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';
import { getEncodedDirectoryPath } from '../../helpers';

type BreadcrumbItemProps = {
  dir: string;
  directoryPath: string[];
  insightType: InsightType;
  menu: MappedInsightType[];
  getRedirectUrl?: (options: { directoryPath: string; insightType: InsightType }) => string;
};

function BreadcrumbItem({
  dir,
  directoryPath,
  insightType,
  menu,
  getRedirectUrl,
}: BreadcrumbItemProps) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleClose = (event: Event | SyntheticEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <Chip
        size="small"
        label={
          <Box display="flex" alignItems="center" key={dir} ref={anchorRef}>
            <BreadcrumbLink
              key={dir}
              color="inherit"
              to={
                getRedirectUrl?.({
                  directoryPath: getEncodedDirectoryPath(directoryPath),
                  insightType,
                }) || {
                  pathname: '',
                  search: `?directoryPath=${getEncodedDirectoryPath(directoryPath)}&insightType=${insightType}`,
                }
              }
            >
              {insightType === InsightType.UniFormat ? getUniFormatDisplayTitle(dir) : dir}
            </BreadcrumbLink>
            {menu.length > 0 && (
              <IconButton
                size="small"
                sx={{ cursor: 'pointer', p: 0, mt: 0.5, ml: 0.5 }}
                id="composition-button"
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
              >
                <ArrowDownSLineIcon size={20} />
              </IconButton>
            )}
          </Box>
        }
        sx={(theme) => ({
          color: theme.palette.custom.mistBlue,
          py: 1.5,
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: theme.palette.custom.boxShadow,
          },
        })}
      />
      <MenuPopup
        open={open}
        anchorRefElement={anchorRef.current}
        handleClose={handleClose}
        menu={menu}
        selectedItem={dir}
        directoryPath={directoryPath.slice(0, directoryPath.length - 1)}
        insightType={insightType}
        getRedirectUrl={getRedirectUrl}
      />
    </>
  );
}

const BreadcrumbLink = styled(Link)(({ theme }) => ({
  fontSize: 14,
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.custom.link,
  },
}));

export default BreadcrumbItem;
